import { render, staticRenderFns } from "./SectionEditorToolbar.vue?vue&type=template&id=4feb2554"
import script from "./SectionEditorToolbar.vue?vue&type=script&lang=ts"
export * from "./SectionEditorToolbar.vue?vue&type=script&lang=ts"
import style0 from "./SectionEditorToolbar.vue?vue&type=style&index=0&id=4feb2554&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports